export default "__VITE_ASSET__Cy9wHpTz__"